import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {AcceptChangeSchema, AcceptData, AcceptDataBackend, EcoVersionType} from "./models-service";

const route_ns = `dicts/eco_version`;

class EcoVersionService {

    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);


  constructor() {
    //
  }

  public async get(): Promise<IResponseResult<EcoVersionType[]>> {
    const response: AxiosResponse["data"] = await this.crud.get();
    if (response && response.data) {
      return {data: response.data as EcoVersionType[] };
    } else {
      return { data: null, message: "" };
    }
  }

  empty() {

  }

}

export default new EcoVersionService();
